import axios from "axios";
import authHeader from "./auth-header";
import UserService from "./user.service";

const API_URL = process.env.REACT_APP_SERVER + "/api/store/";
const CONFIG_URL = process.env.REACT_APP_SERVER + "/api/config/";

class StoreService {

  getProducts() {
    return axios.get(API_URL + "products", { headers: authHeader() });
  }

  getProduct(productId) {
    return axios.get(API_URL + `products/${productId}`, { headers: authHeader() });
  }

  getBasket(userId) {
    return axios.get(API_URL + `basket/${userId}`, { headers: authHeader() });
  }

  addToBasket(userId, productId, quantity) {
    return axios.post(API_URL + `basket/${userId}`, { productId, quantity }, { headers: authHeader() });
  }

  updateBasketItem(userId, itemId, quantity) {
    return axios.put(API_URL + `basket/${userId}/${itemId}`, { quantity }, { headers: authHeader() });
  }

  removeBasketItem(userId, itemId) {
    return axios.delete(API_URL + `basket/${userId}/${itemId}`, { headers: authHeader() });
  }

  checkout(userId) {
    return axios.post(API_URL + `checkout/${userId}`, {}, { headers: authHeader() });
  }

  // Click/activity tracking reuses the existing UserActions log (same
  // mechanism as the rest of the app), just with store-specific type values.
  // Qualtrics return URL configured on the server (QUALTRICS_RETURN_URL);
  // resolves to "" when it is not set.
  getQualtricsReturnUrl() {
    return axios.get(CONFIG_URL + "qualtrics-return-url").then((response) => response.data.url || "");
  }

  logAction(userId, type) {
    return UserService.analytics(userId, [{ type, timestamp: Date.now() }]);
  }
}

export default new StoreService();
